import Vue from "vue";

import Message from "./message";
import User from "./user";
import Setup from "./setup";

Vue.use(Message);
Vue.use(User);
Vue.use(Setup);
